import React from 'react';

const row = (selected, dimmed) => ({
  padding: '10px 12px',
  border: '1px solid #e2e8f0',
  borderRadius: 10,
  background: selected ? '#eef7ff' : '#fff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  cursor: 'pointer',
  opacity: dimmed ? 0.45 : 1,
  filter: dimmed ? 'grayscale(60%)' : 'none'
});
const badge = {
  fontSize: 10,
  padding: "2px 6px",
  borderRadius: 999,
  background: "#eee",
  color: "#666",
  marginLeft: 8,
  border: "1px solid #ddd",
};
const btn = {
  padding: '4px 8px',
  borderRadius: 6,
  border: '1px solid rgba(255, 0, 0, 1)',
  background: 'rgba(255, 0, 0, 1)',
  color: '#fff',
  fontSize: 12,
};

export default function CategoryList({ categories = [], selectedCategoryId, onSelect, onEdit }) {
  return (
    <div className="menu-manager-list" style={{ display: 'flex', flexDirection: 'column', gap: 8,  maxHeight: '75vh',overflowY: 'auto'}}>
      {categories.map(c => {
        // accept both visibility and visibilty (typo) and handle string/number/bool
        const vis = c.visibility ?? c.visibilty;
        const dimmed =
          vis === 0 || vis === '0' || vis === false || vis === 'False';

        const selected = String(c.id) === String(selectedCategoryId);

        return (
          <div
            key={c.id}
            style={row(selected, dimmed)}
            onClick={() => onSelect?.(c)}
            title={dimmed ? 'Hidden category' : undefined}
          >
            <div>
              <div style={{ fontWeight: 600 }}>{c.name} {dimmed && <span style={badge}>Hidden</span>}</div>
              <div style={{ fontSize: 12, color: '#666' }}>code: {c.code ?? c.id} {dimmed ? " - Hidden From App Menu" : ""}</div>
            </div>
            <button
              type="button"
              style={dimmed ? { ...btn,  } : btn}
              onClick={(e) => { e.stopPropagation(); onEdit?.(c); }}
              aria-disabled={dimmed}
              // If you want to fully disable clicking the edit button when hidden:
              // disabled={dimmed}
            >
              Edit
            </button>
          </div>
        );
      })}
      {categories.length === 0 && <div style={{ color: '#777' }}>No categories.</div>}
    </div>
  );
}
